const setResumeAwards = (awards) => ({
    type: 'SET_RESUME_AWARDS',
    awards,
});

export default setResumeAwards;
